export const normalizeProductCategory = (value) => String(value || '').trim().toLowerCase();

export const isKnifeProduct = (product = {}) => {
  const category = normalizeProductCategory(product.category || product.product?.category);
  const presentType = normalizeProductCategory(
    product.presentType ||
    product.presentSubtype ||
    product.giftType ||
    product.subcategory ||
    product.type ||
    product.product?.presentType ||
    product.product?.giftType
  );

  return category === 'knives' || category === 'knife' || presentType === 'knife';
};

export const cartRequiresKnifeVerification = (cart = {}) => (
  Array.isArray(cart.items) &&
  cart.items.some((item) => isKnifeProduct(item.product || item))
);
